<template>
  <div>
    <v-text-field
      clearable
      filled
      rounded
      autofocus
      v-model="search"
      hide-details
      :label="`Buscar ${name || ''}`"
      prepend-inner-icon="fa-search"
      class="d-md-flex mb-5 ml-5  mr-5 search"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "search",
  props: ["name", "loading"],
  computed: {
    search: {
      get: function () {
        return this.$store.state.search;
      },
      set: function (newValue) {
        this.$store.commit("setSearch", newValue);
      },
    },
  },
};
</script>

<style scoped>
  .search {
    max-width: 97%;
  }
</style>